'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/card/style/css');

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _order_info = require('../components/order_info');

var _order_info2 = _interopRequireDefault(_order_info);

var _order_items = require('../components/order_items');

var _order_items2 = _interopRequireDefault(_order_items);

var _order_operation = require('../components/order_operation');

var _order_operation2 = _interopRequireDefault(_order_operation);

var _order_finance = require('../components/order_finance');

var _order_finance2 = _interopRequireDefault(_order_finance);

var _order_change_price = require('../components/order_change_price');

var _order_change_price2 = _interopRequireDefault(_order_change_price);

var _order_close = require('../components/order_close');

var _order_close2 = _interopRequireDefault(_order_close);

var _order_refund = require('../components/order_refund');

var _order_refund2 = _interopRequireDefault(_order_refund);

var _ship_local = require('../components/ship_local');

var _ship_local2 = _interopRequireDefault(_ship_local);

var _ship_express = require('../components/ship_express');

var _ship_express2 = _interopRequireDefault(_ship_express);

var _ship_self = require('../components/ship_self');

var _ship_self2 = _interopRequireDefault(_ship_self);

var _with_couriers = require('../hocs/with_couriers');

var _with_couriers2 = _interopRequireDefault(_with_couriers);

var _package = require('../actions/package');

var _refund = require('../actions/refund');

var _order = require('../actions/order');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Order = _react2.default.createClass({
    displayName: 'Order',

    propTypes: {
        orders: _react.PropTypes.array.isRequired,
        params: _react.PropTypes.object.isRequired
    },
    handlePackage: function handlePackage(orderID, form) {
        this.props.dispatch((0, _package.postPackageIfNeeded)(_extends({
            orderID: orderID
        }, form), this.props.router));
    },
    handleRefund: function handleRefund(orderID, form) {
        this.props.dispatch((0, _refund.postRefundIfNeeded)(_extends({
            orderID: orderID
        }, form)));
    },
    handleClose: function handleClose(orderID, reason) {
        this.props.dispatch((0, _order.postCancelIfNeeded)(orderID, reason, this.props.router));
    },
    render: function render() {
        var _props = this.props,
            orders = _props.orders,
            couriers = _props.couriers,
            params = _props.params;

        var order = orders.filter(function (o) {
            return o.id == params.orderID;
        })[0];
        if (!order) {
            return null;
        }
        var extra = _react2.default.createElement(
            'div',
            null,
            _constants.ORDER_STATUS[order.status] === '待支付' ? _react2.default.createElement(_order_change_price2.default, { order: order }) : null,
            _constants.ORDER_STATUS[order.status] !== '待发货' ? null : _react2.default.createElement(_ship_express2.default, { onSubmit: this.handlePackage.bind(null, order.id), order: order, couriers: couriers }),
            _constants.ORDER_STATUS[order.status] !== '待支付' && _constants.ORDER_STATUS[order.status] !== '已取消' ? _react2.default.createElement(_order_refund2.default, { onSubmit: this.handleRefund.bind(null, order.id), order: order }) : null,
            _constants.ORDER_STATUS[order.status] !== '已取消' ? _react2.default.createElement(_order_close2.default, { onSubmit: this.handleClose.bind(null, order.id), order: order }) : null
        );
        return _react2.default.createElement(
            'div',
            { id: 'order' },
            _react2.default.createElement(
                _card2.default,
                { title: '\u8BA2\u5355\u4FE1\u606F', className: 'order-card', extra: extra },
                _react2.default.createElement(_order_info2.default, { order: order })
            ),
            _react2.default.createElement(
                _card2.default,
                { title: '\u5546\u54C1\u660E\u7EC6', className: 'order-card' },
                _react2.default.createElement(_order_items2.default, { order: order })
            ),
            _react2.default.createElement(
                _card2.default,
                { title: '\u64CD\u4F5C\u8BB0\u5F55', className: 'order-card' },
                _react2.default.createElement(_order_operation2.default, { operations: order.operations })
            ),
            _react2.default.createElement(
                _card2.default,
                { title: '\u8D22\u52A1\u8BB0\u5F55', className: 'order-card' },
                _react2.default.createElement(_order_finance2.default, { finances: order.finances })
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var orders = store.order.orders;
    var couriers = store.courier.couriers;

    return {
        orders: orders.items,
        couriers: couriers.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_couriers2.default)(Order));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/order.js
// module id = 1183
// module chunks = 0